"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserOnboardingExtraDataUpdatedEvent = exports.ExtraDataCommand = void 0;
const validator_1 = require("@leavy/validator");
const domain_events_core_1 = require("@leavy/domain-events-core");
const OnboardingId_1 = require("../domain/OnboardingId");
const base_1 = require("../../base");
const BaseOnboardingCommand_1 = require("./BaseOnboardingCommand");
class ExtraDataCommand extends BaseOnboardingCommand_1.BaseOnboardingCommand {
}
__decorate([
    (0, validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], ExtraDataCommand.prototype, "userId", void 0);
__decorate([
    (0, validator_1.IsEnum)(OnboardingId_1.OnboardingId),
    __metadata("design:type", String)
], ExtraDataCommand.prototype, "onboardingId", void 0);
exports.ExtraDataCommand = ExtraDataCommand;
let UserOnboardingExtraDataUpdatedEvent = class UserOnboardingExtraDataUpdatedEvent extends domain_events_core_1.DomainEventBase {
    constructor(data) {
        super(data);
    }
};
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], UserOnboardingExtraDataUpdatedEvent.prototype, "userId", void 0);
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], UserOnboardingExtraDataUpdatedEvent.prototype, "onboardingId", void 0);
__decorate([
    (0, domain_events_core_1.EventProperty)(),
    __metadata("design:type", String)
], UserOnboardingExtraDataUpdatedEvent.prototype, "dataTypeId", void 0);
UserOnboardingExtraDataUpdatedEvent = __decorate([
    (0, domain_events_core_1.DomainEvent)({
        namespace: base_1.ONBOARDING_SERVICE_NAME,
        name: "user_onboarding_extra_data_updated",
        version: 1,
    }),
    __metadata("design:paramtypes", [Object])
], UserOnboardingExtraDataUpdatedEvent);
exports.UserOnboardingExtraDataUpdatedEvent = UserOnboardingExtraDataUpdatedEvent;
//# sourceMappingURL=ExtraDataCommand.js.map